import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import InstructionVideoGrids from 'components/InstructionVideoGrids';
import FileDownloadGrids from 'components/FileDownloadGrids';
import { videoCategories } from '@silvergatedelivery/constants';
import cache from 'utilities/cache';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(5),
  },
  tabs: {
    'borderRight': `1px solid ${theme.palette.divider}`,
    '& .MuiTabs-flexContainer': {
      alignItems: 'flex-end',
    },
    '& .MuiTabs-indicator': {
      right: 0,
      width: '2px',
    },
  },
  tab: {
    '& .MuiTab-wrapper': {
      fontSize: '0.9rem',
    },
    '&.Mui-selected': {
      'backgroundColor': 'white',
      'boxShadow': '0 2px 4px rgba(0, 0, 0, 0.1)',
      'borderRadius': '4px',
    },
  },
  content: {
    padding: theme.spacing(3),
    backgroundColor: 'rgba(255, 255, 255, 0.66)',
    height: '100%',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    overflowX: 'auto',
    minWidth: '500px',
  },
}));

export default function InstructionCenter() {
  const classes = useStyles();
  const [selectedCategory, setSelectedCategory] = useState(cache.get('app:viewedInstructionVideoCategory') || videoCategories[0].value);

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
  };

  const renderContent = () => {
    if (selectedCategory === 'download') {
      return <FileDownloadGrids category={selectedCategory} />;
    }
    return <InstructionVideoGrids category={selectedCategory} />;
  };

  return (
    <Box className={classes.root}>
      <Grid container spacing={3} wrap="nowrap" style={{ overflowX: 'auto' }}>
        <Grid item sm={2} md={1} style={{ minWidth: '130px' }}>
          <Tabs
            value={selectedCategory}
            onChange={handleCategoryChange}
            orientation="vertical"
            variant="scrollable"
            textColor="primary"
            indicatorColor="primary"
            className={classes.tabs}
          >
            {videoCategories.map((category) => (
              <Tab
                key={category.value}
                label={category.label}
                value={category.value}
                className={classes.tab}
              />
            ))}
          </Tabs>
        </Grid>
        <Grid item sm={10} md={11}>
          <Box className={classes.content}>
            {renderContent()}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

InstructionCenter.propTypes = {
  categoryId: PropTypes.string,
};

